import React, { Fragment } from "react";
import Table from "react-bootstrap/Table";
import ButtonComponent from "../../components/UI/ButtonComponent/ButtonComponent";
import { FormOutlined, DownloadOutlined } from "@ant-design/icons";
import { Pagination, Tooltip } from "antd";
import moment from "moment";
const TableSection = ({
  currentStep,
  selectedAction,
  evidencije,
  handleUpdateButtonClicked,
  openConfirmActionModal,
  initialItemCount,
  onPageChanged,
}) => {
  return (
    <Fragment>
      <br></br>
      {currentStep == 2 && selectedAction == "pregled" && (
        <div style={{ margin: "20px" }}>
          <Table
            bordered
            hover
            responsive
            className="table-responsive izrecene"
            style={{ tableLayout: "fixed", border: "0" }}
          >
            <thead>
              <tr className="tr_table">
                <th scope="col">Redni broj</th>
                <th scope="col">Naziv evidencije</th>
                <th scope="col">Datum predaje</th>
                <th scope="col">Zadnje izmjene unio</th>
                <th scope="col">Pregledaj/Ažuriraj</th>
                <th scope="col">Ispis</th>
              </tr>
            </thead>
            <tbody>
              {evidencije.length > 0 &&
                evidencije.map((element) => {
                  return (
                    <Fragment>
                      <tr>
                        <td>{element.key}</td>
                        <td>{element.nazivEvidencije}</td>
                        <td>{moment(element.datPred).format("DD.MM.YYYY")}</td>
                        <td>{element.zadnjeIzmjeneUnio}</td>
                        <td className="ant_batn"  style={{position:"relative"}}>
                        <Tooltip title={element.oznAktDrustva===2 && "Subjekt je deaktiviran"} getPopupContainer={triggerNode => triggerNode.parentNode} >
                          <ButtonComponent
                            onClick={handleUpdateButtonClicked(
                              element.idPredPosEvid
                            )}
                            variant="secondary"
                            disabled={element.oznAktDrustva===2}
                            style={{pointerEvents: element.oznAktDrustva===2 && "none" }}
                          >
                            <FormOutlined />
                          </ButtonComponent>  {" "}
                        </Tooltip>
                        </td>
                       
                        <td className="ant_batn" >
                        <Tooltip  title={element.oznAktDrustva===2 && "Subjekt je deaktiviran"} getPopupContainer={triggerNode => triggerNode.parentNode} >
                          <ButtonComponent
                            onClick={openConfirmActionModal(
                              element.idPredPosEvid
                            )}
                            variant="secondary"
                            disabled={element.oznAktDrustva===2}
                            style={{pointerEvents: element.oznAktDrustva===2 && "none" }}
                          >
                            <DownloadOutlined />
                          </ButtonComponent> {" "}
                        </Tooltip>
                        </td>
                     
                      </tr>
                    </Fragment>
                  );
                })}
              {evidencije.length === 0 && (
                <tr>
                  <td colSpan="9">
                    <i>Nema dostupnih evidencija.</i>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <Pagination
            defaultCurrent={1}
            defaultPageSize={10}
            total={initialItemCount}
            responsive
            onChange={onPageChanged}
            showSizeChanger={false}
          />
        </div>
      )}
    </Fragment>
  );
};

export default TableSection;
